import React, { useEffect, useState } from "react";
import UserOverviewLabelValue from "./UserOverviewLabelValue";
import useAuth from "../../hooks/useAuth";
import { fieldNameToAssetName } from "../fields/fieldsHelper";

const UserOverviewDetails = ({ userPerson, children }) => {
  const { user } = useAuth();
  const [customFieldConfig, setCustomFieldConfig] = useState(null);

  useEffect(() => {
    if (!user) return;

    setCustomFieldConfig(user.personFieldConfig);
  }, [user]);

  return (
    <React.Fragment>
      {customFieldConfig && customFieldConfig.enabled ? (
        customFieldConfig.customFields.map((value, index) => {
          return (
            <React.Fragment key={`custom_field_${index}`}>
              {value.enabled && (
                <UserOverviewLabelValue
                  label={value.displayName}
                  value={userPerson[fieldNameToAssetName(value.fieldName)]}
                />
              )}
            </React.Fragment>
          );
        })
      ) : (
        <React.Fragment>
          <UserOverviewLabelValue
            label={"Primary Name"}
            value={userPerson.primaryName}
          />
          <UserOverviewLabelValue
            label={"Secondary Name"}
            value={userPerson.secondaryName}
          />
          <UserOverviewLabelValue
            label={"Reference"}
            value={userPerson.reference}
          />
        </React.Fragment>
      )}
      <UserOverviewLabelValue label={"Email"} value={userPerson.email} />
    </React.Fragment>
  );
};

export default UserOverviewDetails;
